/* Slight Crew (prompt 81): account menu, header pill, /pages/crew wallet + meter, product page line, cart box,
   +$5 login bonus claim, "Save my poster". Loaded by snippets/ssc-crew.liquid ('boot') only while the crew is on.
   Logged in: POST {customer_id, ts, sig} (signed in Liquid) to the crew API. /api/crew/me runs at most once per page
   view and is reused from sessionStorage for 5 minutes. Any failure leaves the Liquid copy in place, no error. */
(() => {
  const boot = document.getElementById('ssc-crew-boot');
  if (!boot) return;
  const B = boot.dataset;
  const cid = B.cid || '';
  const signed = !!(cid && B.ts && B.sig && B.api);
  const ME_KEY = `ssc-crew-me:${cid}`;
  const BONUS_KEY = `ssc-crew-bonus:${cid}`;
  const TTL = 5 * 60 * 1000;
  const UNIT = 10000; // $100 of counted spend = $5
  const store = {
    get(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } },
    set(k, v) { try { sessionStorage.setItem(k, v); } catch (e) { /* private mode */ } },
    del(k) { try { sessionStorage.removeItem(k); } catch (e) { /* private mode */ } },
  };
  const money = (c) => '$' + (Math.max(0, c) / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/\.00$/, '');
  const day = (iso) => new Date(iso).toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  const esc = (s) => String(s).replace(/[&<>"']/g, (ch) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch]));
  const unitsFrom = (cents, toNext) => (cents >= toNext ? 1 + Math.floor((cents - toNext) / UNIT) : 0);

  // ---------- account menu (header)
  const acctBtn = document.querySelector('[data-ssc-acct-open]');
  const acctMenu = document.querySelector('[data-ssc-acct-menu]');
  if (acctBtn && acctMenu) {
    const setOpen = (open) => {
      acctMenu.hidden = !open;
      acctBtn.setAttribute('aria-expanded', String(open));
    };
    acctBtn.addEventListener('click', (event) => {
      event.preventDefault();
      setOpen(acctMenu.hidden);
    });
    document.addEventListener('click', (event) => {
      if (!acctMenu.hidden && !acctMenu.contains(event.target) && !acctBtn.contains(event.target)) setOpen(false);
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !acctMenu.hidden) {
        setOpen(false);
        acctBtn.focus();
      }
    });
  }

  // ---------- crew API
  const api = (B.api || '').replace(/\/+$/, '');
  const post = (path, extra) => fetch(api + path, {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    credentials: 'omit',
    body: JSON.stringify({ ...extra, customer_id: cid, ts: B.ts, sig: B.sig }),
  });

  /** Claim a quest (C3). Resolves to the server's answer ({status: claimed|already|…}) or null when it can't. */
  async function quest(body) {
    if (!signed) return null;
    try {
      const res = await post('/api/crew/quest', body);
      const data = await res.json().catch(() => null);
      store.del(ME_KEY); // the crew page should show it on the next view
      return data && typeof data === 'object' ? { ...data, http: res.status } : null;
    } catch (e) {
      return null;
    }
  }
  /** VIP custom piece request (C4, members only). Resolves to the server's answer or null when it can't. */
  async function custom(body) {
    if (!signed) return null;
    try {
      const res = await post('/api/crew/custom', body);
      const data = await res.json().catch(() => null);
      store.del(ME_KEY);
      return data && typeof data === 'object' ? { ...data, http: res.status } : null;
    } catch (e) {
      return null;
    }
  }
  // For the quiz page (assets/ssc-quiz.js), which loads before this file, and the VIP page (assets/ssc-vip.js).
  window.sscCrew = { signed, loggedIn: !!cid, loginUrl: B.loginUrl || '/account/login', quest, custom, me: () => me() };
  document.dispatchEvent(new CustomEvent('ssc-crew:ready'));

  let mePromise = null;
  function me() {
    if (!signed) return Promise.resolve(null);
    if (mePromise) return mePromise;
    mePromise = (async () => {
      // +$5 login bonus: once per browser session; the server pays once per customer, ever.
      if (!store.get(BONUS_KEY)) {
        store.set(BONUS_KEY, '1');
        try {
          if ((await post('/api/crew/login-bonus')).ok) store.del(ME_KEY);
        } catch (e) { /* next session tries again */ }
      }
      try {
        const cached = JSON.parse(store.get(ME_KEY) || 'null');
        if (cached && Date.now() - cached.at < TTL) return cached.data;
      } catch (e) { /* ignore */ }
      try {
        const res = await post('/api/crew/me');
        if (!res.ok) return null;
        const data = await res.json();
        if (!data || !data.meter || !Array.isArray(data.credits)) return null;
        store.set(ME_KEY, JSON.stringify({ at: Date.now(), data }));
        return data;
      } catch (e) {
        return null;
      }
    })();
    return mePromise;
  }

  const pendingOf = (d) => (d.flagged ? d.pending.filter((p) => p.kind !== 'login') : d.pending);
  const soonest = (d) => d.credits.filter((c) => c.kind !== 'refund' && c.expires_at)
    .sort((a, b) => Date.parse(a.expires_at) - Date.parse(b.expires_at))[0];

  // ---------- header pill: "$5 soon" when only a pending bonus exists
  function pill(d) {
    if (Number(B.balance) > 0) return;
    const p = pendingOf(d).reduce((s, x) => s + x.amount, 0);
    if (!p) return;
    document.querySelectorAll('[data-ssc-crew-pill]').forEach((el) => {
      el.textContent = `${money(p)} soon`;
      el.hidden = false;
    });
  }

  // ---------- /pages/crew wallet rows, refund line, meter
  function crewPage(d) {
    const root = document.querySelector('[data-ssc-crew-page]');
    if (!root) return;
    const rows = root.querySelector('[data-ssc-crew-rows]');
    const soon = Date.now() + 7 * 86400000;
    const items = d.credits.filter((c) => c.kind !== 'refund').map((c) => {
      const what = `${money(c.remaining)} · ${c.label}${c.order_name ? ` · order ${c.order_name}` : ''}`;
      const cls = c.expires_at && Date.parse(c.expires_at) < soon ? ' class="is-soon"' : '';
      return `<li${cls}><span>${esc(what)}</span><span>${c.expires_at ? `Expires ${esc(day(c.expires_at))}` : 'Never expires'}</span></li>`;
    });
    pendingOf(d).forEach((p) => {
      items.push(`<li class="is-pend"><span>${esc(`${money(p.amount)} · ${p.label}`)}</span><span>${esc(p.note)}</span></li>`);
    });
    if (rows && items.length) {
      rows.innerHTML = items.join('');
      rows.hidden = false;
    }
    const refund = d.credits.filter((c) => c.kind === 'refund').reduce((s, c) => s + c.remaining, 0);
    const refundEl = root.querySelector('[data-ssc-crew-refund]');
    if (refundEl && refund > 0) {
      root.querySelector('[data-ssc-crew-refund-amt]').textContent = `Refund credit ${money(refund)}`;
      refundEl.hidden = false;
    }
    const meter = root.querySelector('[data-ssc-crew-meter]');
    if (meter) {
      const have = d.meter.cents;
      meter.querySelector('[data-ssc-crew-meter-have]').textContent = `${money(have)} of $100`;
      meter.querySelector('[data-ssc-crew-meter-left]').textContent = `${money(d.meter.to_next)} to your next $5`;
      const bar = meter.querySelector('[data-ssc-crew-meter-bar]');
      bar.setAttribute('aria-label', `${money(have)} of $100`);
      bar.querySelector('i').style.width = `${Math.max(3, Math.min(100, have / 100))}%`;
      meter.hidden = false;
    }
  }

  // ---------- product page line (follows the selected size's price)
  function pdp(d) {
    document.querySelectorAll('[data-ssc-crew-pdp]').forEach((el) => {
      const priceNode = document.querySelector('[data-ssc-main-price]');
      const paint = () => {
        let price = Number(el.dataset.price) || 0;
        const shown = (priceNode?.textContent || '').replace(/[^0-9.]/g, '');
        if (shown) price = Math.round(parseFloat(shown) * 100);
        if (!price) return;
        const units = unitsFrom(price, d.meter.to_next);
        if (units) {
          el.classList.add('ssc-earn--fill');
          el.innerHTML = `<span class="ssc-earn__coin" aria-hidden="true">+${money(units * 500)}</span><span>This one <b>fills your meter</b>. ${money(units * 500)} S-Bucks lands when it ships.</span>`;
        } else {
          el.classList.remove('ssc-earn--fill');
          el.innerHTML = `<span class="ssc-earn__coin" aria-hidden="true">$5</span><span>Adds <b>${money(price)}</b> to your cash-back meter. <b>${money(d.meter.to_next - price)} more</b> after this and you get $5.</span>`;
        }
      };
      paint();
      if (priceNode) new MutationObserver(paint).observe(priceNode, { childList: true, characterData: true, subtree: true });
    });
  }

  // ---------- cart drawer + /cart box (re-rendered by Shopify on every cart change)
  // Writes only when the node isn't already showing what we last wrote (Shopify's re-render resets it), so the
  // MutationObserver below can't loop.
  const fill = (node, html) => {
    if (!node || (node.dataset.crewHtml && node.dataset.crewHtml === node.innerHTML)) return;
    node.innerHTML = html;
    node.dataset.crewHtml = node.innerHTML;
  };

  function cart(d) {
    document.querySelectorAll('[data-ssc-crew-cart]').forEach((el) => {
      const counted = Number(el.dataset.counted) || 0;
      const units = unitsFrom(counted, d.meter.to_next);
      let meterLine = '';
      if (counted > 0) {
        meterLine = units
          ? `This order adds <b>${money(counted)}</b> to your meter: <b>+${money(units * 500)} S-Bucks</b> when it ships.`
          : `This order adds <b>${money(counted)}</b> to your meter. <b>${money(d.meter.to_next - counted)} more</b> to your next $5.`;
      }
      const text = el.querySelector('[data-ssc-crew-cart-text]');
      const login = pendingOf(d).find((p) => p.kind === 'login');
      if (el.hasAttribute('data-slim')) {
        // Cart line (prompt 102, drawer and /cart): one line, no "S-Bucks" wording. Credit ready, or the earn rule.
        if (Number(B.balance) > 0) fill(text, `<b>${money(Number(B.balance))} credit ready</b> · use it at checkout`);
        else fill(text, 'Earn <b>$5 back</b> on every $100');
        return;
      }
      if (Number(B.balance) > 0) {
        const s = soonest(d);
        const runs = s ? ` ${money(s.remaining)} runs out ${esc(day(s.expires_at))}.` : '';
        fill(text, `Pick "Store credit" at checkout to use it.${runs}${meterLine ? `<br>${meterLine}` : ''}`);
      } else if (login) {
        fill(el, `<div class="ssc-sbucks__r"><b>${money(login.amount)} is waiting</b><span class="ssc-sbucks__chip">Pending</span></div>`
          + `<small>Your login ${money(login.amount)} unlocks when this order ships.${counted > 0 ? ` This order also adds <b>${money(counted)}</b> to your meter.` : ''}</small>`);
      } else if (meterLine) {
        fill(text, meterLine);
      }
    });
  }

  me().then((d) => {
    hunt(d);
    if (!d) return;
    pill(d);
    crewPage(d);
    crewC3(d);
    crewVip(d);
    pdp(d);
    cart(d);
    let queued = false;
    new MutationObserver(() => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => {
        queued = false;
        cart(d);
      });
    }).observe(document.body, { childList: true, subtree: true });
  });

  // ---------- C4 on /pages/crew: the VIP card (members; the upsell is plain Liquid)
  const monthDay = (iso) => new Date(iso).toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  function crewVip(d) {
    const card = document.querySelector('[data-ssc-crew-vip]');
    const v = d.vip;
    if (!card || !v || !v.member) return;
    const set = (sel, text) => { const el = card.querySelector(sel); if (el) el.textContent = text; };
    set('[data-v-plan]', `VIP · ${v.plan === 'yearly' ? 'yearly' : 'monthly'}`);
    if (v.since) set('[data-v-since]', `Member since ${new Date(v.since).toLocaleDateString('en-US', { month: 'short', year: 'numeric' })}`);
    if (v.next_credit_at) set('[data-v-next]', `$10 lands ${monthDay(v.next_credit_at)}`);
    set('[data-v-credit]', v.credit && v.credit.expires_at ? `Expires ${monthDay(v.credit.expires_at)}` : 'On its way');
    set('[data-v-custom]', v.custom.left > 0 ? '1 left this month' : 'Sent this month');
    card.hidden = false;
  }

  // ---------- C3 on /pages/crew: quests, collection book, cash drops log, birthday pop-up
  const SIZE = { 15: 'Big', 10: 'Mid', 5: 'Small' };
  const weekday = (iso) => new Date(iso).toLocaleDateString('en-US', { weekday: 'long' });
  function crewC3(d) {
    const root = document.querySelector('[data-ssc-crew-page]');
    if (!root || !d.quests || !d.book) return;
    const Q = d.quests;
    const row = (k) => root.querySelector(`.ssc-crew__q[data-q="${k}"]`);
    const done = (k, text, chip) => {
      const r = row(k);
      if (!r) return;
      r.classList.add('is-done');
      if (text) r.querySelector('[data-q-text]').textContent = text;
      const act = r.querySelector('[data-q-act]');
      if (act) act.outerHTML = `<span class="ssc-crew__chip ssc-crew__chip--done" data-q-act>${esc(chip)}</span>`;
    };
    root.querySelector('[data-ssc-crew-q-earned]').textContent = `${money(Q.earned_cents)} earned so far`;
    const rv = row('review');
    if (!Q.review.enabled) {
      rv.querySelector('[data-q-text]').textContent = "1 per order, once it's approved. Coming soon.";
      rv.querySelector('[data-q-act]').outerHTML = '<span class="ssc-crew__chip" data-q-act>Coming soon</span>';
    } else {
      const n = Q.review.waiting;
      rv.querySelector('[data-q-text]').textContent = `1 per order, once it's approved.${n ? ` ${n} order${n === 1 ? ' is' : 's are'} waiting for yours.` : ''}`;
    }
    if (Q.skun.found) done('skun', `Found on ${weekday(Q.skun.found_at)}. New hiding spot every Monday.`, 'Found');
    if (Q.quiz.done) {
      const name = ((window.sscAnime || {})[Q.quiz.anime] || {}).name || Q.quiz.anime;
      done('quiz', `You got ${name}. Once only.`, 'Done');
    }
    if (Q.birthday.saved) {
      const md = new Date(Date.UTC(2024, Q.birthday.month - 1, Q.birthday.day)).toLocaleDateString('en-US', { month: 'long', day: 'numeric', timeZone: 'UTC' });
      done('birthday', `Saved: ${md}. $5 every year in your birthday week.`, 'Saved');
    }
    root.querySelector('[data-ssc-crew-quests]').hidden = false;

    // Collection book
    const B3 = d.book;
    const book = root.querySelector('[data-ssc-crew-book]');
    root.querySelector('[data-ssc-crew-book-sum]').textContent = `${B3.owned_total} design${B3.owned_total === 1 ? '' : 's'} · ${B3.full} page${B3.full === 1 ? '' : 's'} full`;
    const pagesEl = root.querySelector('[data-ssc-crew-book-pages]');
    const ownedEl = root.querySelector('[data-ssc-crew-book-owned]');
    let open = Math.max(0, B3.pages.findIndex((p) => !p.claimed && p.owned.length));
    const paint = () => {
      pagesEl.innerHTML = B3.pages.map((p, i) => {
        const k = Math.min(p.owned.length, p.goal);
        const stamps = Array.from({ length: p.goal }, (_, j) => `<i class="${j < k ? 'on' : ''}"></i>`).join('');
        // G6b: full before launch = shown full, paid by hand ("Ask us about your reward").
        const chip = p.claimed ? `<span class="ssc-crew__chip ssc-crew__chip--done">${money(p.reward_cents)} paid</span>`
          : p.prelaunch_full ? '<span class="ssc-crew__chip ssc-crew__chip--done">Ask us about your reward</span>'
          : `<span>Fill it: ${money(p.reward_cents)}</span>`;
        return `<button type="button" class="ssc-crew__world${p.claimed || p.prelaunch_full ? ' is-claimed' : ''}" data-i="${i}" aria-expanded="${i === open}">`
          + `<span class="top"><span class="nm">${esc(p.anime)}</span><span class="sz">${SIZE[p.goal] || ''}</span></span>`
          + `<span class="ssc-crew__stamps" role="img" aria-label="${k} of ${p.goal} designs">${stamps}</span>`
          + `<span class="ft"><span>${k} / ${p.goal}</span>${chip}</span></button>`;
      }).join('');
      const p = B3.pages[open];
      if (p) {
        const left = p.goal - p.owned.length;
        const more = p.missing_more ? `<li class="miss">+ ${p.missing_more} more to go</li>` : '';
        const contact = root.dataset.contact || '/pages/get-in-touch';
        const note = p.claimed
          ? `Page full. ${money(p.reward_cents)} S-Bucks paid on ${esc(day(p.claimed_at))}.`
          : p.prelaunch_full ? `Page full from orders before the Slight Crew started. <a href="${esc(contact)}">Ask us about your reward</a>.`
          : left <= 0 ? `Page full. Your ${money(p.reward_cents)} lands within a day.` : `${left} more design${left === 1 ? '' : 's'} fills this page and pays ${money(p.reward_cents)}.`;
        ownedEl.innerHTML = `<span class="ssc-crew__eyebrow">${esc(p.anime)} · your page</span><ul>`
          + p.owned.map((h) => `<li>${esc(h)}</li>`).join('')
          + (p.claimed || left <= 0 ? '' : p.missing.map((m) => `<li class="miss">${esc(m)}</li>`).join('') + more)
          + `</ul><span class="ssc-crew__note">${note}</span>`;
      }
      pagesEl.querySelectorAll('.ssc-crew__world').forEach((b) => b.addEventListener('click', () => { open = Number(b.dataset.i); paint(); }));
    };
    paint();
    const small = root.querySelector('[data-ssc-crew-book-small]');
    if (B3.small.length) {
      small.insertAdjacentHTML('beforeend', B3.small.map((a) => `<span class="ssc-crew__chip">${esc(a)}</span>`).join(''));
      small.hidden = false;
    }
    book.hidden = false;

    // Cash drops log
    const list = root.querySelector('[data-ssc-crew-drops-list]');
    const now = Date.now();
    list.innerHTML = d.drops && d.drops.length ? d.drops.map((x) => {
      const gone = x.expires_at && Date.parse(x.expires_at) < now;
      const [head, ...rest] = String(x.reason).split(' · ');
      const sub = [rest.join(' · '), x.expires_at ? `${gone ? 'Expired' : 'Expires'} ${day(x.expires_at)}.` : ''].filter(Boolean).join('. ').replace('..', '.');
      const dt = new Date(x.created_at);
      return `<li${gone ? ' class="is-gone"' : ''}><span class="d">${esc(dt.toLocaleDateString('en-US', { month: 'short' }))}<br>${String(dt.getDate()).padStart(2, '0')}</span>`
        + `<span class="w"><b>${esc(head)}</b><small>${esc(sub.charAt(0).toUpperCase() + sub.slice(1))}</small></span><span class="a">+${money(x.amount)}</span></li>`;
    }).join('') : '<li class="is-empty">No drops yet. They land by surprise: birthdays, your anime winning Anime Wars, new drop days.</li>';
    root.querySelector('[data-ssc-crew-drops]').hidden = false;

    // Birthday pop-up
    const dlg = root.querySelector('[data-ssc-crew-bday]');
    const openBtn = root.querySelector('[data-ssc-crew-bday-open]');
    if (dlg && openBtn && typeof dlg.showModal === 'function') {
      const form = dlg.querySelector('[data-ssc-crew-bday-form]');
      const msg = dlg.querySelector('[data-ssc-crew-bday-msg]');
      openBtn.addEventListener('click', () => { msg.textContent = ''; dlg.showModal(); });
      dlg.querySelector('[data-ssc-crew-bday-close]').addEventListener('click', () => dlg.close());
      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        const month = Number(form.month.value), dayN = Number(form.day.value);
        if (!month || !dayN) { msg.textContent = 'Pick a month and a day.'; return; }
        const btn = form.querySelector('[type="submit"]');
        btn.disabled = true;
        const r = await quest({ quest: 'birthday', month, day: dayN });
        btn.disabled = false;
        if (r && (r.status === 'saved' || r.status === 'already')) {
          const md = new Date(Date.UTC(2024, r.month - 1, r.day)).toLocaleDateString('en-US', { month: 'long', day: 'numeric', timeZone: 'UTC' });
          done('birthday', `Saved: ${md}. $5 every year in your birthday week.`, 'Saved');
          dlg.close();
        } else {
          msg.textContent = r && r.error === 'bad date' ? "That date doesn't exist. Pick another." : "Couldn't save it right now. Try again later.";
        }
      });
    } else if (openBtn) {
      openBtn.hidden = true;
    }
  }

  // ---------- Find S-KUN (C3): peeks from this week's page only; tap to claim $1 (logged in)
  async function publicSpot() {
    try {
      const c = JSON.parse(store.get('ssc-skun-spot') || 'null');
      if (c && Date.now() - c.at < 10 * 60 * 1000) return c.spot;
    } catch (e) { /* ignore */ }
    try {
      const res = await fetch(`${api}/api/crew/skun`, { credentials: 'omit' });
      if (!res.ok) return null;
      const { spot } = await res.json();
      store.set('ssc-skun-spot', JSON.stringify({ at: Date.now(), spot }));
      return spot;
    } catch (e) {
      return null;
    }
  }
  const herePath = () => (location.pathname.toLowerCase().replace(/\/+$/, '') || '/');
  async function hunt(d) {
    const tpl = document.getElementById('ssc-skun-hunt');
    if (!tpl || !api) return;
    let spot;
    if (d && d.quests) {
      if (d.quests.skun.found) return;
      spot = d.quests.skun.spot;
    } else if (signed) {
      return; // logged in but the API is down: no S-KUN rather than a claim that fails
    } else {
      spot = await publicSpot();
    }
    if (!spot || herePath() !== spot) return;
    document.body.appendChild(tpl.content.cloneNode(true));
    const peek = document.querySelector('[data-skun-peek]');
    const card = document.querySelector('[data-skun-card]');
    const show = (html) => {
      card.querySelector('[data-skun-body]').innerHTML = html;
      card.hidden = false;
      card.querySelector('button, a')?.focus();
    };
    card.addEventListener('click', (e) => { if (e.target.closest('[data-skun-close]')) card.hidden = true; });
    peek.addEventListener('click', async () => {
      if (!signed) {
        show(`<span class="ssc-crew-eyebrow">You found me</span><span class="ssc-skun-card__money">$1</span>`
          + `<span>Log in to claim your $1. I move every Monday.</span>`
          + `<a class="ssc-skun-card__btn" href="${esc(B.loginUrl || '/account/login')}">Log in</a><button type="button" class="ssc-skun-card__x" data-skun-close>Later</button>`);
        return;
      }
      peek.disabled = true;
      const r = await quest({ quest: 'skun', page: herePath() });
      if (r && (r.status === 'claimed' || r.status === 'already')) {
        peek.remove();
        show(r.status === 'claimed'
          ? `<span class="ssc-crew-eyebrow">You found me</span><span class="ssc-skun-card__money">+$1</span><span>S-Bucks landed in your account. I move every Monday.</span><button type="button" class="ssc-skun-card__btn" data-skun-close>Nice</button>`
          : `<span class="ssc-crew-eyebrow">Already found</span><span>You got me this week. I move every Monday.</span><button type="button" class="ssc-skun-card__btn" data-skun-close>OK</button>`);
      } else {
        peek.disabled = false;
        show(`<span>Couldn't claim it right now. Try again in a bit.</span><button type="button" class="ssc-skun-card__btn" data-skun-close>OK</button>`);
      }
    });
  }

  // ---------- Save my poster: PNG drawn on a canvas; phones get the share sheet with the file, else a download
  const saveBtn = document.querySelector('[data-ssc-crew-save]');
  const poster = document.querySelector('[data-ssc-crew-poster]');
  if (saveBtn && poster) {
    saveBtn.addEventListener('click', async () => {
      saveBtn.disabled = true;
      try {
        const blob = await drawPoster(poster);
        const file = new File([blob], 'slight-crew-bounty.png', { type: 'image/png' });
        const phone = window.matchMedia('(pointer: coarse)').matches;
        if (phone && navigator.canShare && navigator.canShare({ files: [file] })) {
          try {
            await navigator.share({ files: [file], title: 'My Slight Crew bounty' });
            return;
          } catch (e) {
            if (e && e.name === 'AbortError') return;
          }
        }
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = file.name;
        document.body.appendChild(a);
        a.click();
        a.remove();
        setTimeout(() => URL.revokeObjectURL(url), 10000);
      } catch (e) {
        /* nothing saved; the button stays usable */
      } finally {
        saveBtn.disabled = false;
      }
    });
  }

  function svgImage(svg) {
    return new Promise((resolve) => {
      if (!svg) return resolve(null);
      const clone = svg.cloneNode(true);
      clone.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
      clone.setAttribute('width', '640');
      clone.setAttribute('height', '600');
      const img = new Image();
      img.onload = () => resolve(img);
      img.onerror = () => resolve(null);
      img.src = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(new XMLSerializer().serializeToString(clone))}`;
    });
  }

  async function drawPoster(fig) {
    const DISPLAY = '"Dela Gothic One", Impact, sans-serif';
    const LABEL = '"Barlow Condensed", "Arial Narrow", sans-serif';
    try {
      await Promise.all([document.fonts.load(`96px ${DISPLAY}`), document.fonts.load(`800 48px ${LABEL}`)]);
    } catch (e) { /* system fallback */ }
    const art = await svgImage(fig.querySelector('svg'));
    const render = (withArt) => {
      const W = 1080, H = 1350;
      const c = document.createElement('canvas');
      c.width = W; c.height = H;
      const g = c.getContext('2d');
      g.fillStyle = '#fffef5';
      g.fillRect(0, 0, W, H);
      g.fillStyle = 'rgba(21,21,21,0.12)';
      for (let y = 6; y < H; y += 24) for (let x = 6; x < W; x += 24) g.fillRect(x, y, 2.4, 2.4);
      g.save();
      g.translate(W / 2, H / 2);
      g.rotate((2 * Math.PI) / 180);
      const pw = 760, ph = 1090, x0 = -pw / 2, y0 = -ph / 2;
      g.fillStyle = '#151515';
      g.fillRect(x0 + 18, y0 + 22, pw, ph);
      g.fillStyle = '#efdcae';
      g.fillRect(x0, y0, pw, ph);
      g.lineWidth = 12;
      g.strokeStyle = '#151515';
      g.strokeRect(x0 + 6, y0 + 6, pw - 12, ph - 12);
      g.fillStyle = '#151515';
      g.textAlign = 'center';
      g.textBaseline = 'alphabetic';
      g.font = `132px ${DISPLAY}`;
      g.fillText('WANTED', 0, y0 + 170);
      const box = 620, bx = -box / 2, by = y0 + 210;
      g.fillStyle = '#ffffff';
      g.fillRect(bx, by, box, box);
      g.lineWidth = 9;
      g.strokeRect(bx, by, box, box);
      if (withArt && art) g.drawImage(art, bx + 70, by + 85, 480, 450);
      const fit = (text, size, font, max) => {
        let s = size;
        do { g.font = font.replace('{s}', s); s -= 2; } while (g.measureText(text).width > max && s > 20);
      };
      const who = `@${fig.dataset.handle} · ${fig.dataset.rank}`.toUpperCase();
      fit(who, 56, `800 {s}px ${LABEL}`, pw - 80);
      g.fillText(who, 0, by + box + 90);
      const bounty = `BOUNTY ${fig.dataset.bounty}`;
      fit(bounty, 84, `{s}px ${DISPLAY}`, pw - 80);
      g.fillText(bounty, 0, by + box + 190);
      g.restore();
      g.fillStyle = '#151515';
      g.textAlign = 'center';
      g.font = `800 34px ${LABEL}`;
      g.fillText('SLIGHT CREW · SOMESLIGHT.COM', W / 2, H - 34);
      return new Promise((resolve, reject) => {
        try {
          c.toBlob((b) => (b ? resolve(b) : reject(new Error('empty'))), 'image/png');
        } catch (e) {
          reject(e);
        }
      });
    };
    try {
      return await render(true);
    } catch (e) {
      return render(false); // a browser that taints the canvas with SVG art still gets a poster
    }
  }
})();
